import { Button } from '../../../../../../common/html/button'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { Popup } from '../../../../../../common/popup'
import TextEllipsis from '../../../../../../common/textEllipsis'
import { SaveListContent } from './SaveListContent'

export const PopupSaveList = ({ isShow, handleClose, handleApply }) => {
  return (
    isShow && (
      <Popup
        appendStyleModal={{ width: 600, height: '60%' }}
        appendStyleContent={{
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
          backgroundColor: '#F3F3F3',
          borderRadius: 4,
          width: '100%',
          height: '100%',
        }}
      >
        <Element
          className="dFlex justifyContentBetween alignItemsCenter"
          style={{
            borderBottom: '1px solid #e5e5e8',
            paddingBottom: 8,
          }}
        >
          <Element
            elementName="span"
            className="fw500"
            style={{
              fontSize: 20,
              color: '#0553A5',
            }}
          >
            <TextEllipsis
              isI18n
              zIndexTooltip={7}
              text={'companyAnalysis.peerAnalysis.SAVE_LIST_TITLE'}
            />
          </Element>
          <Icon
            className="icon-delete"
            style={{ color: '#9C9C9C' }}
            onClick={handleClose}
          />
        </Element>

        <SaveListContent />

        <div className="dFlex justifyContentEnd gap1">
          <Button
            isI18n
            label={'companyAnalysis.peerAnalysis.CLOSE'}
            style={{
              borderRadius: 4,
              minWidth: 100,
              padding: '6px 12px',
              cursor: 'pointer',
              border: '1px solid #D5D5D5',
              backgroundColor: '#FFFFFF',
            }}
            action={handleClose}
          />
          <Button
            isI18n
            label={'companyAnalysis.peerAnalysis.APPLY'}
            style={{
              borderRadius: 4,
              border: 'none',
              color: '#FFFFFF',
              minWidth: 100,
              padding: '6px 12px',
              cursor: 'pointer',
              backgroundColor: '#2c73e8',
            }}
            action={handleApply}
          />
        </div>
      </Popup>
    )
  )
}
